var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpGoodsimageNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1280,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652,1056v64H460v-64a32,32,0,0,0-32-32H396a32,32,0,0,0-32,32v96a64,64,0,0,0,64,64H684a64,64,0,0,0,64-64v-96a32,32,0,0,0-32-32H684A32,32,0,0,0,652,1056Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.51,643.12l24.62,91.44a25.93,25.93,0,0,0,18.31,18.31l91.44,24.62c14.83,4,14.83,25,0,29l-91.44,24.62a25.93,25.93,0,0,0-18.31,18.31l-24.62,91.44c-4,14.83-25,14.83-29,0l-24.62-91.44a25.93,25.93,0,0,0-18.31-18.31l-91.44-24.62c-14.83-4-14.83-25,0-29l91.44-24.62a25.93,25.93,0,0,0,18.31-18.31l24.62-91.44C1045.48,628.29,1066.52,628.29,1070.51,643.12Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.85,328l35.4,131.45a37.27,37.27,0,0,0,26.32,26.32L956,521.15c21.31,5.73,21.31,36,0,41.7l-131.45,35.4a37.27,37.27,0,0,0-26.32,26.32L762.85,756c-5.73,21.31-36,21.31-41.7,0l-35.4-131.45a37.27,37.27,0,0,0-26.32-26.32L528,562.85c-21.31-5.73-21.31-36,0-41.7l131.45-35.4a37.27,37.27,0,0,0,26.32-26.32L721.15,328C726.88,306.67,757.12,306.67,762.85,328Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827,128.81c-17.38-11.38-45.71-28.07-90.86-41.7C685.39,71.77,624.77,64,556,64S426.61,71.77,375.82,87.11c-45.16,13.63-73.48,30.32-90.86,41.7a63.93,63.93,0,0,0-25.31,74.83C358.86,486.45,360.05,525.77,364,868.11c.09,8.23.43,37.07.71,60.28A32,32,0,0,0,396.62,960H715.38a31.94,31.94,0,0,0,31.91-31.61c.11-9.21.25-21,.38-32a32,32,0,0,0-32-32.37h-256c-3.84-333.11-5.49-388.56-101.11-667.35C388.93,181.07,447.73,160,556,160s167.07,21.07,197.41,36.65q-3,8.67-5.83,17.06A32,32,0,0,0,777.88,256h33.48a32,32,0,0,0,30.23-21.51q5.17-14.94,10.76-30.85A63.93,63.93,0,0,0,827,128.81Z",
    style: {
      fill: "#282828"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpGoodsimageNormal);
export default __webpack_public_path__ + "static/media/hp_goodsimage_normal.a1b5f8d9105875e70b083122debe65f6.svg";
export { ForwardRef as ReactComponent };